import { render, staticRenderFns } from "./ticketItem.vue?vue&type=template&id=3fe2df63&scoped=true"
import script from "./ticketItem.vue?vue&type=script&lang=ts"
export * from "./ticketItem.vue?vue&type=script&lang=ts"
import style0 from "./ticketItem.vue?vue&type=style&index=0&id=3fe2df63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe2df63",
  null
  
)

export default component.exports